export enum DestinationModalNames {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
}